/**
 * Transiente HTTP-Status, bei denen eine unveränderte Wiederholung sinnvoll
 * ist: kein Netz (0), Timeout (408), Lock-Konflikt (423, vgl. Backend
 * `rescue_from RedisMutex::LockError`), Too Early/Many Requests (425/429)
 * und temporäre Serverfehler. 4xx-Validierungsfehler (insb. 422) und
 * 409-Konflikte sind permanent.
 */
const RETRYABLE_HTTP_STATUS = [0, 408, 423, 425, 429, 500, 502, 503, 504];

/** HTTP 409: Ziel-Zustand existiert bereits (z.B. Movement schon bestätigt). */
export const HTTP_STATUS_CONFLICT = 409;

/**
 * Klassifiziert einen im Adapter gefangenen Remote-Fehler. Versteht sowohl
 * rohe `HttpErrorResponse` als auch das von `ErrorService.convert` geworfene
 * flache `IMitsError` - beide tragen `status`. Fehler ohne Status (z.B.
 * Programmierfehler) gelten als permanent.
 *
 * @param error Gefangener Remote-Fehler
 * @returns true, wenn eine unveränderte Wiederholung sinnvoll ist
 */
export function isRetryableRemoteError(error: unknown): boolean {
  const status = statusOf(error);
  return status !== undefined && RETRYABLE_HTTP_STATUS.includes(status);
}

/**
 * Liefert den HTTP-Status eines gefangenen Remote-Fehlers (undefined, wenn
 * keiner vorhanden ist).
 *
 * @param error Gefangener Remote-Fehler
 * @returns Numerischer HTTP-Status oder undefined
 */
export function statusOf(error: unknown): number | undefined {
  const status = (error as { status?: unknown })?.status;
  return typeof status === 'number' ? status : undefined;
}
